import { createGlobalStyle, css } from 'styled-components';
import normalize from 'styled-normalize';
import { CookieBotStyles } from './cookiebot.style';

const removeTapHighlights = css`
  -webkit-tap-highlight-color: transparent !important;
  -webkit-touch-callout: none !important;
`;

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  body {
    color: ${({ theme }) => theme.color?.text.body};
  }

  *, *:before, *:after {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.fontFamily?.body}, system-ui, sans-serif;
    font-feature-settings: 'ss01' on, 'ss03' on, 'ss05' on;
    ${({theme}) => theme.isApp && removeTapHighlights})
  }

  main {
    width: 100%;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  button {
    cursor: pointer;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  img:-moz-loading {
    visibility: hidden;
  }

  ${CookieBotStyles}
`;
